module.exports = __webpack_public_path__ + "img/vanode.986b7dd.png";